// const ServicePath = "https://devadmin.medhorizone.com:3003/"
// const ServicePath = "http://192.168.0.94:7000/"
// const ServicePath = "http://192.168.0.83:5000/" // parasu Local Port
// const ServicePath = "http://192.168.0.39:7000/" // parasu Local Port

const ServicePath = "https://admin.medhorizone.com/"
// const ServicePath = "http://localhost:7000/"
// const MobileServicePath = "https://devapi.medhorizone.com/"
// const MobileServicePath = "http://localhost:7000/"
const MobileServicePath = "https://api.medhorizone.com:5000/"


export default ServicePath;
export { MobileServicePath };